.button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: var(--size-control-md);
  padding: 0 var(--space-4);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-size: var(--type-label-size);
  line-height: var(--type-label-line);
  font-weight: var(--weight-medium);
  letter-spacing: var(--tracking-body);
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  transition:
    background-color var(--duration-fast-02) var(--ease-standard),
    border-color var(--duration-fast-02) var(--ease-standard),
    color var(--duration-fast-02) var(--ease-standard);
}

.button:focus-visible {
  outline: 2px solid var(--color-focus);
  outline-offset: 2px;
}

.sm {
  min-height: var(--size-control-sm);
  padding: 0 var(--space-3);
}

.lg {
  min-height: var(--size-control-lg);
  padding: 0 var(--space-5);
  font-size: var(--type-body-size);
}

.fullWidth {
  width: 100%;
}

.wrap {
  white-space: normal;
  text-align: start;
}

.label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wrap .label {
  overflow: visible;
}

/* DESIGN.md 1.5: главная — акцент с белым текстом; вторичная и третичная — белые с рамкой line;
   цвет у кнопки только тогда, когда он значит «главное действие» или «опасно». */
.primary {
  background: var(--color-interactive);
  color: var(--color-text-on-color);
  font-weight: var(--weight-semibold);
}

.primary:hover {
  background: var(--color-interactive-hover);
  color: var(--color-text-on-color);
}

.primary:active {
  background: var(--color-interactive-active);
}

.secondary,
.tertiary {
  background: var(--color-secondary);
  border-color: var(--color-secondary-border);
  color: var(--color-secondary-text);
}

.secondary:hover,
.tertiary:hover {
  background: var(--color-secondary-hover);
  color: var(--color-secondary-text);
}

.secondary:active,
.tertiary:active {
  background: var(--color-secondary-active);
}

.ghost {
  background: transparent;
  color: var(--color-text-primary);
}

.ghost:hover {
  background: var(--color-layer-hover);
  color: var(--color-text-primary);
}

.ghost:active {
  background: var(--color-layer-hover-strong);
}

.danger {
  background: var(--color-danger);
  color: var(--color-text-on-color);
  font-weight: var(--weight-semibold);
}

.danger:hover {
  background: var(--color-danger-hover);
  color: var(--color-text-on-color);
}

.danger:active {
  background: var(--color-danger-active);
}

.dangerGhost {
  background: transparent;
  color: var(--color-error);
}

.dangerGhost:hover {
  background: var(--color-error-bg);
  color: var(--color-error);
}

.button:disabled,
.button[aria-disabled='true']:not([aria-busy='true']) {
  cursor: not-allowed;
  background: var(--color-layer-1);
  border-color: transparent;
  color: var(--color-text-disabled);
}

.ghost:disabled,
.dangerGhost:disabled {
  background: transparent;
}

.button[aria-busy='true'] {
  cursor: progress;
}

.iconOnly {
  flex: none;
  padding: 0;
  width: var(--size-control-md);
}

.iconOnly.sm {
  width: var(--size-control-sm);
}

.iconOnly.lg {
  width: var(--size-control-lg);
}

.badge {
  position: absolute;
  top: 3px;
  inset-inline-end: 3px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: var(--radius-pill);
  background: var(--color-interactive);
  color: var(--color-text-on-color);
  font-size: 10px;
  line-height: 16px;
  font-weight: var(--weight-semibold);
  letter-spacing: 0;
  font-variant-numeric: tabular-nums;
  pointer-events: none;
}

.badgeDot {
  position: absolute;
  top: 8px;
  inset-inline-end: 9px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--color-interactive);
  pointer-events: none;
}

@media (forced-colors: active) {
  .button {
    border-color: ButtonText;
  }

  .badgeDot {
    background: CanvasText;
  }
}
